import React, { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import ChangePasswordForm from '../components/ChangePasswordForm';
import FeeTracking from '../components/FeeTracking';

const ProfilePage = () => {
    const { user } = useContext(AuthContext);

    if (!user) {
        return (
            <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 rounded-3xl bg-white/70 p-12 text-center shadow-xl backdrop-blur">
                <h2 className="text-2xl font-semibold text-slate-900">Đang tải thông tin...</h2>
            </div>
        );
    }

    return (
        <div className="space-y-6">
            <div className="rounded-3xl bg-white/70 p-8 shadow-xl backdrop-blur">
                <h1 className="text-3xl font-bold text-slate-900 mb-2">Thông tin cá nhân</h1>
                <p className="text-slate-600">Quản lý thông tin tài khoản và bảo mật</p>
            </div>

            <div className="rounded-3xl bg-white/70 p-8 shadow-xl backdrop-blur">
                <div className="space-y-6">
                    <div className="rounded-2xl bg-white p-6 border border-slate-200">
                        <h2 className="text-xl font-semibold text-slate-900 mb-4">Thông tin tài khoản</h2>
                        <div className="flex items-center gap-6">
                            <div className="flex h-20 w-20 items-center justify-center rounded-full bg-indigo-100 text-indigo-600">
                                <i className="fas fa-user text-3xl" aria-hidden></i>
                            </div>
                            <div className="space-y-2">
                                <div>
                                    <label className="text-sm font-medium text-slate-500">Họ tên</label>
                                    <p className="text-lg font-semibold text-slate-900">{user.name}</p>
                                </div>
                                <div>
                                    <label className="text-sm font-medium text-slate-500">Email</label>
                                    <p className="text-slate-700">{user.email}</p>
                                </div>
                                <div>
                                    <label className="text-sm font-medium text-slate-500">Vai trò</label>
                                    <span className={`inline-flex rounded-full px-3 py-1 text-xs font-semibold mt-1 ${
                                        user.role === 'admin'
                                            ? 'bg-red-100 text-red-800'
                                            : 'bg-green-100 text-green-800'
                                    }`}>
                                        {user.role === 'admin' ? 'Quản trị viên' : 'Sinh viên'}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <ChangePasswordForm
                        onSuccess={(message) => {
                            // Better success notification
                            const notification = document.createElement('div');
                            notification.className = 'fixed top-4 right-4 z-50 rounded-xl bg-green-600 text-white px-6 py-4 shadow-lg';
                            notification.innerHTML = `
                                <div class="flex items-center gap-3">
                                    <i class="fas fa-check-circle text-xl"></i>
                                    <span class="font-medium">${message}</span>
                                </div>
                            `;
                            document.body.appendChild(notification);

                            setTimeout(() => {
                                notification.remove();
                            }, 5000);
                        }}
                    />

                    {user?.role === 'student' && <FeeTracking />}
                </div>
            </div>
        </div>
    );
};

export default ProfilePage;